import IndividualsActivePage from './pages/ActiveIndividuals.page';
import IndividualsCheckedPage from './pages/CheckedIndividuals.page';
import IndividualsStatsPage from './pages/IndividualsStats.page';
import IndividualDetails from './pages/IndividualDetails.page';

IndividualsActivePage.path = '/individuals/active';
IndividualsCheckedPage.path = '/individuals/registered';
IndividualsStatsPage.path = '/individuals';
IndividualDetails.path = '/individuals/:id';

export default {
  pages: {
    IndividualsActivePage,
    IndividualsStatsPage,
    IndividualDetails,
    IndividualsCheckedPage,
  }
};
